import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=07a52890&scoped=true"
import script from "./relationship.vue?vue&type=script&lang=js"
export * from "./relationship.vue?vue&type=script&lang=js"
import style0 from "./relationship.vue?vue&type=style&index=0&id=07a52890&prod&lang=stylus&scoped=true"
import style1 from "./relationship.vue?vue&type=style&index=1&id=07a52890&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a52890",
  null
  
)

export default component.exports